import { useTheme } from 'foundations-theming/utils';
import { createCssVarsFromTheme } from 'foundations-theming/utils/createCssVars';
import { createGlobalStyle } from 'styled-components';
export const APPLIED_CSS_VARS_FLAG = '--css-vars-applied';
const LOCAL_CSS_VARS_KEY = 'trellis:local-dev-only-use-css-variables';
const safeLocalStorageGet = key => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};
export const GlobalCSSVariables = createGlobalStyle(() => {
  const theme = useTheme();
  const isLocalCssVars = safeLocalStorageGet(LOCAL_CSS_VARS_KEY) === 'true';
  if (isLocalCssVars && theme.theme) {
    const cssVars = createCssVarsFromTheme(theme.theme);
    return {
      ':root': Object.assign({}, cssVars, {
        [APPLIED_CSS_VARS_FLAG]: 'true'
      })
    };
  }
  const cssVars = createCssVarsFromTheme(theme);
  return {
    ':root': Object.assign({}, cssVars, {
      [APPLIED_CSS_VARS_FLAG]: 'true'
    })
  };
});